// extracted by mini-css-extract-plugin
export var colorSquare = "_r4-0";
export var danger = "_r4-5";
export var lightPink = "_r4-8";
export var neutralBlue = "_r4-7";
export var neutralYellow = "_r4-6";
export var normal = "_r4-1";
export var primary = "_r4-2";
export var primaryLight = "_r4-3";
export var solidBlack = "_r4-g";
export var solidGreen = "_r4-b";
export var solidLightBlue = "_r4-d";
export var solidNavy = "_r4-c";
export var solidOrange = "_r4-f";
export var solidPink = "_r4-e";
export var solidRed = "_r4-9";
export var solidYellow = "_r4-a";
export var success = "_r4-4";